/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';

/**
 * 
 * @export
 * @interface NullableMoneyCalculationDataTransferObject
 */
export interface NullableMoneyCalculationDataTransferObject {
    /**
     * 
     * @type {number}
     * @memberof NullableMoneyCalculationDataTransferObject
     */
    percentageChangeAgainstPreviousPeriod?: number | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof NullableMoneyCalculationDataTransferObject
     */
    value?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof NullableMoneyCalculationDataTransferObject
     */
    valuePreviousPeriod?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof NullableMoneyCalculationDataTransferObject
     */
    valueGranular?: { [key: string]: NullableMoneyOutput; };
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof NullableMoneyCalculationDataTransferObject
     */
    valueGranularPreviousPeriod?: { [key: string]: NullableMoneyOutput; };
}

/**
 * Check if a given object implements the NullableMoneyCalculationDataTransferObject interface.
 */
export function instanceOfNullableMoneyCalculationDataTransferObject(value: object): value is NullableMoneyCalculationDataTransferObject {
    return true;
}

export function NullableMoneyCalculationDataTransferObjectFromJSON(json: any): NullableMoneyCalculationDataTransferObject {
    return NullableMoneyCalculationDataTransferObjectFromJSONTyped(json, false);
}

export function NullableMoneyCalculationDataTransferObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): NullableMoneyCalculationDataTransferObject {
    if (json == null) {
        return json;
    }
    return {
        
        'percentageChangeAgainstPreviousPeriod': json['percentageChangeAgainstPreviousPeriod'] === undefined ? undefined : json['percentageChangeAgainstPreviousPeriod'] === null ? null : json['percentageChangeAgainstPreviousPeriod'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : NullableMoneyOutputFromJSON(json['value']),
        'valuePreviousPeriod': json['valuePreviousPeriod'] === undefined ? undefined : json['valuePreviousPeriod'] === null ? null : NullableMoneyOutputFromJSON(json['valuePreviousPeriod']),
        'valueGranular': json['valueGranular'] == null ? undefined : (mapValues(json['valueGranular'], NullableMoneyOutputFromJSON)),
        'valueGranularPreviousPeriod': json['valueGranularPreviousPeriod'] == null ? undefined : (mapValues(json['valueGranularPreviousPeriod'], NullableMoneyOutputFromJSON)),
    };
}

export function NullableMoneyCalculationDataTransferObjectToJSON(json: any): NullableMoneyCalculationDataTransferObject {
    return NullableMoneyCalculationDataTransferObjectToJSONTyped(json, false);
}

export function NullableMoneyCalculationDataTransferObjectToJSONTyped(value?: NullableMoneyCalculationDataTransferObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percentageChangeAgainstPreviousPeriod': value['percentageChangeAgainstPreviousPeriod'],
        'value': NullableMoneyOutputToJSON(value['value']),
        'valuePreviousPeriod': NullableMoneyOutputToJSON(value['valuePreviousPeriod']),
        'valueGranular': value['valueGranular'] == null ? undefined : (mapValues(value['valueGranular'], NullableMoneyOutputToJSON)),
        'valueGranularPreviousPeriod': value['valueGranularPreviousPeriod'] == null ? undefined : (mapValues(value['valueGranularPreviousPeriod'], NullableMoneyOutputToJSON)),
    };
}

